export default "__VITE_ASSET__BGEq5fXu__"